module.exports = __webpack_public_path__ + "static/Egypt-6dfe6d6267d311fe6157fa5cbc9dbd47.jpg";